var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',[(_vm.checking)?_c('el-col',[_c('p',[_vm._v("Checking...")])]):_c('el-col',[(_vm.needApprove)?_c('el-button',{attrs:{"loading":_vm.approving,"type":"primary"},on:{"click":_vm.approve}},[_vm._v(" "+_vm._s(this.$t("approve"))+" ")]):_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }